import FpStandardLogin from 'forepaas/client-authority-manager/FpStandardLogin/FpStandardLogin.jsx'

class StandardLogin extends FpStandardLogin {
}

export default StandardLogin
